// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"136":"component---src-pages-products-[handle]-js","672":"component---src-pages-test-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"136":"324ed428112a86417cd4","672":"0aba43a49804e096562f","678":"1d9ba4132d90c8ac7959","883":"1100cbf9df22682cd8a1"}[chunkId] + ".js";
};